/**
 * 时时彩，通用模板，1分彩，2分彩，5分彩 投注选择区
 */
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import Loader from '../../../components/icon/Loader.jsx';
import { LOTTERY_METHOD_SWITCHER } from '../../../constants/lotterys/config'
import * as Rules from '../../../constants/lotterys/rules/rulesEntry'
import SelectModes from './SelectModes.jsx'
import AddBets from './AddBets.jsx'
import BetLhc from './bet/Bet_Lhc.jsx'

class LhcSelectArea extends React.Component {

  constructor(props) {
    super(props);
    this.updateCurrentMethods = this.updateCurrentMethods.bind(this);
    this.setCurrentBetExtend = this.setCurrentBetExtend.bind(this);
    this.handleChangePrizeMode = this.handleChangePrizeMode.bind(this);
    this.setCurrentMethod = this.setCurrentMethod.bind(this);
    this.addOrder = this.addOrder.bind(this);
    this.handleChangeModes = this.handleChangeModes.bind(this);
    this.initCurrentBet = this.initCurrentBet.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.tabChange = this.tabChange.bind(this);

    this.state = {
      currentMethod: {},
      currentBet: {},
      currentTab: 0,
      resetToken: _.random(99999999)
    }
  }

  componentDidMount() {
    this.updateCurrentMethods(this.props)
  }

  componentWillReceiveProps(nextProps) {
    return this.updateCurrentMethods(nextProps)
  }

  // 添加投注
  addOrder(betDirect) {
    const { submit, display } = this.state.currentBet;
    const { windowId } = this.props;
    const __methods = this.props.__METHOD.toJS();
    // 投注是0则返回
    if (this.state.currentBet.display.length == 0) { return; }
    // 重置数据
    this.setState({
      currentBet: this.initCurrentBet(this.state.currentMethod),
      resetToken: _.random(99999999)
    })
    if(!betDirect){
      // 添加到订单
      this.props.$$LOTTERY.addLhcOrder(submit, display, windowId)
      return;
    }
    // 直接投注, 清空追号，以及购彩栏已有选号
    this.props.$$LOTTERY.removeOrder(windowId, null);
    this.props.$$LOTTERY.addLhcOrder(submit, display, windowId);
    _.delay(this.props.submit.bind(this, true), 200)

  }

  // 设置当前注数和投注额
  setCurrentBetExtend(result) {
    let _currentBet = _.cloneDeep(this.state.currentBet);
    _currentBet.display = result.display;
    _currentBet.submit = result.submit;
    this.setState({
      currentBet: _currentBet
    })
  }

  // 初始化当前投注数据
  initCurrentBet(currentMethod) {
    let _currentBet = {};
    _currentBet.display = {
      num: 0,
      money: 0
    };
    _currentBet.prize = currentMethod.prize[currentMethod.prize.length - 1].value;
    _currentBet.mode = currentMethod.modes[0];
    _currentBet.codes = [];
    _.forEach(currentMethod.data_label[0].label[0].label, function (item, index) {
      let code = {
        type: item.type,
        color: item.color,
        desc: item.desc,
        name: item.name,
        num: item.num,
        methodid: item.methodid,
        menuid: item.menuid,
        value: ''
      };
      _currentBet.codes.push(code);
    })
    return _currentBet;
  }

  // 设置当前投注单注奖金
  handleChangePrizeMode() {
    let _currentBet = _.cloneDeep(this.state.currentBet);
    _currentBet.prize = ReactDOM.findDOMNode(this.refs.prize).value;
    this.setState({
      currentBet: _currentBet
    })
    Rules.execute(null, this.state.currentMethod, _currentBet, this.setCurrentBetExtend, 'lhc')
  }

  // 设置当前投注信息
  setCurrentMethod(methods, props,categoryName = null, menuid = null) {
	  let currentCategory = lotteryService.setCurrentCategory(methods, props.params.lotteryFlag, props.params.methodType, categoryName);
    const { lotteryFlag } = this.props.params;
    const _static = window.METHODS.static[lotteryFlag];
    let _currentMethod = _static;
    const _dynamic = _.find(window.METHODS.dynamic, { menuid: _currentMethod.data_label[0].label[0].label[0].menuid });
    _currentMethod.prize = _dynamic ? _dynamic.prize_group : null;
    if (!_currentMethod.prize) {
      this.props.$$BASE.openAlert('请联系上级开通该玩法');
      return window.location.href = '#/'
    }
	  // 回传当前玩法
	  this.props.updateCurrentMethod(_currentMethod, currentCategory)
    _currentMethod.modes = [{ modeid: 1, name: '元', rate: 1 }]

    this.setState({
      currentMethod: _currentMethod,
      currentBet: this.initCurrentBet(_currentMethod)
    })
  }

  // 设置当前投注模式： 元角分
  handleChangeModes(mode) {
    return;
  }

  // 改变输入值
  handleInput(money, methodid) {
    let _bet = _.cloneDeep(this.state.currentBet);
    let code = _.find(_bet.codes, { methodid: methodid });
    code.value = money;
    this.setState({
      currentBet: _bet
    })
    Rules.execute(null, this.state.currentMethod, _bet, this.setCurrentBetExtend, 'lhc')
  }

  // 切换彩种，或者第一次加载完成动态区时设置当前玩法
  updateCurrentMethods(props) {

    const __methods = props.__METHOD.toJS();
    const windowId = props.windowId;

    // 首先判断动态和静态数据是否已经完成加载
    if (!__methods.staticLoadDone || !__methods.dynamicLoadDone) {
      return true;
    }

    // 判断当前区是否和路由中的lotteryFlag一致，如果一致继续
    if (__methods.windows[windowId] &&
      __methods.windows[windowId].flag == props.params.lotteryFlag &&
      !_.isEmpty(this.state.currentMethod)) {
      return true;
    }

    if (_.intersection(_.split(window.location.hash, '/'), ['lhc']).length == 0) {
      return;
    }

    this.props.$$LOTTERY.setWindowMethods(props.params.lotteryFlag, windowId);
    this.setCurrentMethod(window.METHODS, props);

    return true;
  }

  // teb切换
  tabChange() {
    this.setState({
      currentTab: !this.state.currentTab
    })
  }

  render() {

    const __methods = this.props.__METHOD.toJS();
    const windowId = this.props.windowId;
    const params = this.props.params;

    return (
      <div className="fl ssc-select-area" >
        {
          // 未完成当前彩种设置前显示LOADING
          !__methods.windows[windowId] ||
            params.lotteryFlag != __methods.windows[windowId].flag ||
            _.isEmpty(this.state.currentMethod) ?
            <Loader /> :
            <div className='lotteryLeft'>
              <div className="lotteryGroup lhc-lotteryGroup">
                <ul >
                  <li className={this.state.currentTab == 0 ? 'hover' : ''}>特码</li>
                  {/*<li onClick={this.tabChange} className={this.state.currentTab == 1 ? 'hover' : ''}>开奖结果</li>*/}
                </ul>
                {/*<div className="fandian ab" id="nfdprize">*/}
                  {/*<select*/}
                      {/*ref='prize'*/}
                      {/*defaultValue={this.state.currentMethod.prize[this.state.currentMethod.prize.length - 1].value}*/}
                      {/*onChange={this.handleChangePrizeMode.bind(this)}*/}
                    {/*>*/}
                      {/*{*/}
                        {/*this.state.currentMethod.prize.map((item, index) =>*/}
                          {/*<option key={index} value={item.value} >{item.label}</option>*/}
                        {/*)*/}
                      {/*}*/}
                    {/*</select>*/}
                {/*</div>*/}
              </div>
              {
                this.state.currentTab == 0 ?
                  <BetLhc
                    prize={_.find(this.state.currentMethod.prize, { value: Number(this.state.currentBet.prize) }).label}
                    items={this.state.currentBet.codes}
                    onChange={this.handleInput}
                    resetToken={this.state.resetToken}
                  /> : ''
              }
              {/*{*/}
                {/*this.state.currentTab == 1 ?*/}
                  {/*<HistoryLhc windowId={windowId} __methods={__methods} /> : ''*/}
              {/*}*/}
              <div className='addOrderBox'>
                <div className="currentBet">
                  <p>已选 <span >{this.state.currentBet.display.length || 0}</span> 注</p>
                  <p>共 <span className='money'>{_.sum(_.map(this.state.currentBet.display, 'money')) || 0}</span> 元</p>
                  <br className="clearfix" />
                </div>
                <AddBets
                    currentNum={this.state.currentBet.display.length || 0}
                    currentMoney={_.sum(_.map(this.state.currentBet.display, 'money')) || 0}
                    addFn={this.addOrder}
                    windowId={windowId}
                    submit={this.props.submit}
                    openTrack={this.props.openTrack}
                    params={this.props.params}
                />
                <div className="fandian" id="nfdprize">
                    <select
                        ref='prize'
                        defaultValue={this.state.currentMethod.prize[this.state.currentMethod.prize.length - 1].value}
                        onChange={this.handleChangePrizeMode.bind(this)}
                    >
                        {
                            this.state.currentMethod.prize.map((item, index) =>
                                <option key={index} value={item.value} >{item.label}</option>
                            )
                        }
                    </select>
                </div>
                <SelectModes
                    modes={this.state.currentMethod.modes}
                    value={this.state.currentBet.mode.rate}
                    onChange={this.handleChangeModes}
                />

                {/*<div className='select-times'></div>*/}

              </div>
            </div>
        }
      </div>
    );
  }
}

reactMixin(LhcSelectArea.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __METHOD: state.method
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LhcSelectArea)